import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { ActivatedRoute } from '@angular/router';
import { EMPTY, Subscription } from 'rxjs';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { CenterLanguage } from '../../../models/center-model/center-language.model';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-centers-center-dashboard',
  templateUrl: './centers-center-dashboard.component.html',
  styleUrls: ['./centers-center-dashboard.component.scss']
})
export class CentersCenterDashboardComponent implements OnInit, OnDestroy {

  center;
  schedules;
  existingSchedules;
  languages;
  currencies;
  centerTypeList;
  assignedLanguages: CenterLanguage[];
  getCenterLanguagesSubscription: Subscription;
  getCenterInfoSubscription: Subscription;
  getCenterSchedulesSubscription: Subscription;
  getCenterSubscriptionRefresh: Subscription;
  getCenterTypeListSubscription: Subscription;

  constructor(private centersCentersService: CentersCentersService,
    private activatedRoute: ActivatedRoute,
    private snackbarService: SnackBarService,
    private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getCenterInfo();
    this.getCenterSchedules();
    this.getCenterTypeList();
    this.getCenterExistingSchedules();
    this.getCenterSubscriptionRefresh = this.centersCentersService.refreshCenterListen().subscribe(
      (res) => {
        this.getCenterInfo();
        this.getCenterSchedules();
      }
    );
  }

  private getCenterInfo() {
    const internalId = this.activatedRoute.snapshot.params['centerid'];
    this.getCenterInfoSubscription = this.centersCentersService.getCenterInfo(internalId).pipe(
      tap(o => this.center = o),
      tap(o => this.assignedLanguages = this.center.CenterLanguageList),
      tap(o => this.getCenterConfigurationInfo()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private getCenterSchedules() {
    const internalId = this.activatedRoute.snapshot.params['centerid'];
    this.getCenterSchedulesSubscription = this.centersCentersService.getCenterScheduleList(internalId).pipe(
      tap(o => this.schedules = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private getCenterTypeList() {
    this.getCenterTypeListSubscription = this.centersCentersService.getCenterTypes().pipe(
      tap(res => this.centerTypeList = res)
    ).subscribe();
  }

  private getCenterConfigurationInfo() {
    const internalId = this.activatedRoute.snapshot.params['centerid'];
    this.getCenterLanguagesSubscription = this.centersCentersService.getCenterConfigurationInfo(internalId).pipe(
      tap(o => this.languages = o.languages),
      tap(o => this.currencies = o.currencies),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private getCenterExistingSchedules() {
    const internalId = this.activatedRoute.snapshot.params['centerid'];
    this.centersCentersService.getCenterExistingSchedules(internalId).pipe(
      tap(o => this.existingSchedules = o)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-store-alt', 'stores-page.store detail', '/centers', [new BRoute('stores-page.store locator', '/centers'), new BRoute('stores-page.store detail')]));
  }

  ngOnDestroy() {
    if (this.getCenterInfoSubscription) { this.getCenterInfoSubscription.unsubscribe(); }
    if (this.getCenterSchedulesSubscription) { this.getCenterSchedulesSubscription.unsubscribe(); }
    if (this.getCenterSubscriptionRefresh) { this.getCenterSubscriptionRefresh.unsubscribe(); }
  }
}
